module.exports = __webpack_public_path__ + "img/van-green.e406b88b.svg";